import { Link } from "react-router-dom";
import HomeIcon from "./Icons/HomeIcon";
import ForwardIcon from "./Icons/ForwardIcon";
import { IoMdExpand } from "react-icons/io";
import React, { useMemo } from "react";
import { RouteName } from "constants/route";
import SosIcon from "./Icons/SosIcon";
import { Badge } from "antd";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { jwtDecode } from "jwt-decode";
import { ERole } from "models/account";

// Wrapper component to fix TypeScript issue with react-icons
const ExpandIcon: React.FC = () => <IoMdExpand />;

interface IProps {
  expand: boolean;
  toggleExpand: () => void;
}

export default function Header({ toggleExpand }: IProps) {
  const { sosCount } = useDataLoadingContext();
  const pathName = useMemo(() => {
    const paths = window.location.pathname.split("/");
    const path = paths[1] === "" ? "Home" : paths[1];
    return path.replace(/-/g, " ");
  }, [window.location.pathname]); // eslint-disable-line
  const accountDashboard = () => {
    try {
      const token = localStorage.getItem("token");
      const data: any = jwtDecode(token ?? "");
      const role = data.role;

      switch (role) {
        case ERole.ADMIN:
        case ERole.SUPER_ADMIN:
        case ERole.DISPATCH:
          return RouteName.DASHBOARD;
        case ERole.CASHER:
          return RouteName.DRIVER;
        default:
          return RouteName.TRIP;
      }
    } catch (_) { }
    return "#";
  };

  return (
    <header className="w-full mb-6 flex items-center">
      <h1 className="text-[#636363] text-2xl font-medium pr-4 pl-2 border-r border-r-divider inline-block capitalize">
        {pathName}
      </h1>
      <div className="pl-4 flex items-center flex-wrap grow pr-4 ">
        <div className="flex items-center w-full">
          <Link className="text-black" to={accountDashboard()}>
            <HomeIcon />
          </Link>
          <span className="px-2">
            <ForwardIcon />
          </span>
          <span className="inline-block text-sm font-normal capitalize">
            {pathName}
          </span>
          <div className="grow" />
          <div className="flex items-center justify-end gap-x-3">
            <button
              className="text-[#636363] hover:text-black transition-all duration-300 text-3xl"
              onClick={toggleExpand}
              type="button"
            >
              <ExpandIcon />
            </button>
            <Badge
              count={sosCount}
              showZero={true}
              size="small"
              className="bg-gray-300 p-1 rounded-full"
            >
              <Link to={RouteName.SOS} className="text-3xl text-red-600">
                <SosIcon />
              </Link>
            </Badge>
          </div>
        </div>
      </div>
    </header>
  );
}
